import React, { useState, useRef, useEffect } from "react";
import Layout from "../components/shared/layout";
import InnerPageBanner from "../components/shared/innerPageBanner";
import ImageIcons from "../components/imageComponent/ImageIcons";
import { FaMinus, FaPlus } from "react-icons/fa";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import SEO from "../components/shared/seo";
import axios from "axios";
import { MdCall } from "react-icons/md";
import { IoMdMail } from "react-icons/io";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [allfaqs, setAllfaqs] = useState([]);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}admin/getFaqs`,
        { withCredentials: true }
      );
      const data = response.data;

      const filteredData = data
        .filter(
          (item) => item.isActive === true && item.isCustomerFAQ === false
        )
        .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));

      setAllfaqs(filteredData);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  useEffect(() => {
    console.log("Updated allfaqs:", allfaqs);
  }, [allfaqs]);

  return (
    <>
      <SEO
        title="FAQs - myInternet | Your Questions Answered"
        description="Find answers to all your questions about myInternet. Get detailed information on our services, pricing, support, and more in our comprehensive FAQ section."
      />
      <Layout>
        <InnerPageBanner
          title="Frequently Asked Questions"
          innerPageBanner={ImageIcons.FAQs}
        />
        <section>
          <div className="container !max-w-[1400px]">
            <div className="flex max-lg:flex-col gap-[30px]">
              <div className="xl:w-[25%] lg:w-[30%]">
                <div className="bg-[#F48533] p-[20px] rounded-[8px] sticky xl:top-[150px] top-[130px]">
                  <h4 className="text-white xl:text-[24px] md:text-[22px] text-[20px] md:leading-[32px] leading-[30px]">Can’t find your answer? <br />We’re here to help.</h4>
                  <span className="flex gap-[8px] items-center text-[16px] text-[#fff] duration-500 mb-[8px]"><MdCall className="text-[25px] min-w-[25px]" />+91 9464001234</span>
                  <span className="flex gap-[8px] items-center text-[16px] text-[#fff] duration-500"><IoMdMail className="text-[25px] min-w-[25px]" />info@myinternet.services</span>
                  </div>             
              </div>

              <div className="mx-auto bg-white rounded-lg xl:w-[75%] lg:w-[70%]">
              {allfaqs.length > 0 ? (
                allfaqs.map((faq, index) => (
                  <AccordionItem
                    key={faq._id}
                    active={activeIndex === index}
                    handleToggle={() => handleToggle(index)}
                    faq={faq}
                  />
                ))
              ) : (
                <p className="text-center text-gray-500">No FAQs available.</p>
              )}
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

const AccordionItem = ({ handleToggle, active, faq }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (contentRef.current) {
      setHeight(active ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [active]);

  return (
    <div className="mb-[20px] shadow-[0px_3px_15px_0px_rgba(0,0,0,0.1)] overflow-hidden rounded-[10px]">
      <div
        className={`p-[20px] flex justify-between items-center cursor-pointer ${
          active ? "bg-[#f48533] text-white" : ""
        }`}
        onClick={handleToggle}
      >
        <h5 className="mb-0 lg:text-[20px] text-[18px]">{faq.questions}</h5>
        <span>{active ? <FaMinus /> : <FaPlus />}</span>
      </div>
      <div
        ref={contentRef}
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: height }}
      >
        <div className="p-[20px]">
          <p className="mb-0">{faq.answers}</p>
          {faq.answerList && (
            <ul className="mt-[15px]">
              {faq.answerList.map((item, i) => (
                <li key={i} className="mb-[8px] text-[16px] relative pl-[25px]">
                  <IoCheckmarkDoneSharp className="text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]" />
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
